import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ToTopButton() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      data-testid="to-top-button"
      className={`fixed bottom-20 md:bottom-5 right-5 z-40 inline-flex items-center gap-1.5 rounded-full border border-[#1A3A5C]/15 bg-white/85 backdrop-blur px-3.5 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-[#1A3A5C] shadow-[0_12px_30px_rgba(26,58,92,0.18)] transition-[opacity,transform] duration-300 hover:bg-[#1A3A5C] hover:text-white ${
        show ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-3"
      }`}
    >
      <ArrowUp size={14} /> Top
    </button>
  );
}
